import React, { useEffect } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import config from "../../config";

const About = () => {
    useEffect(() => {
        document.title = `About Us | Agile Seekers`;
        document.getElementById("bodywrap").className = "aboutmain";
    }, []);
    return (
        <>
            <Navbar />
            <section className="about-banner">
                <Container fluid>
                    <Row>
                        <Col className="px-0 abimg">
                            <h2>About AgileSeekers</h2>
                            <Image
                                src={`${config.BASE_URL}/assets/images/about.jpg`}
                                className="img-fluid"
                                alt="about"
                            />
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className="about-bottom">
                <Container>
                    <Row className="about-top">
                        <Col md={12}>
                            <h3>Overview</h3>
                            <p>
                                Founded in 2020, AgileSeekers has quickly established itself as
                                a leading provider of premium training and consulting services.
                                We specialize in delivering industry-recognized certifications
                                in Agile methodologies, including Scrum, SAFe, Kanban, Project
                                Management, and ICP-ACC. With a commitment to providing
                                high-quality, both classroom and online learning experiences, we
                                serve students and professionals across more than 20 countries
                                globally.
                            </p>
                            <p>
                                Our team comprises passionate professionals who are deeply
                                invested in meeting the growing demands of the industry.
                                AgileSeekers is dedicated to addressing the challenges posed by
                                ever-evolving technologies and equipping individuals and
                                organizations with the skills needed to succeed.
                            </p>
                        </Col>
                        <Col md={12}>
                            <h3>Our Reach</h3>
                            <p>
                                Since our inception, we have trained over 10,000 students and
                                professionals in diverse fields, including Agile, Scrum, SAFe,
                                Kanban and Project Management. Through our global presence, we
                                have helped countless individuals build careers, gain
                                certifications, and stay competitive in their industries.
                            </p>
                        </Col>
                    </Row>
                    <Row className="about-grid">
                        <Col md={6}>
                            <h3>What We Do</h3>
                            <Image
                                src={`${config.BASE_URL}/assets/images/line.png`}
                                className="img-fluid ab-line"
                                alt="line"
                            />
                            <p>
                                In today’s fast-paced world, professionals need to continuously
                                expand their skillsets, solve complex problems, and deliver
                                successful outcomes. At AgileSeekers, we play a pivotal role in
                                facilitating the growth of these skills by offering a wide range
                                of certifications and training programs designed to bridge
                                knowledge gaps and enable career advancement.
                            </p>
                            <p>
                                We are committed to staying ahead of technological advancements
                                and continuously evolving our course offerings to meet the needs
                                of the global market.
                            </p>
                        </Col>
                        <Col md={6}>
                            <Image
                                src={`${config.BASE_URL}/assets/images/wwo.png`}
                                className="img-fluid"
                                alt="wwo"
                            />
                        </Col>
                    </Row>
                    <Row className="about-grid">
                        <Col md={6} className="ord2">
                            <Image
                                src={`${config.BASE_URL}/assets/images/hwd.png`}
                                className="img-fluid"
                                alt="hwd"
                            />
                        </Col>
                        <Col md={6}>
                            <h3>How we do it</h3>
                            <Image
                                src={`${config.BASE_URL}/assets/images/line.png`}
                                className="img-fluid ab-line"
                                alt="line"
                            />
                            <p>
                                AgileSeekers combines innovative training methods, expert
                                instructors, and an extensive course catalog to provide
                                comprehensive learning experiences. Whether through in-person or
                                online sessions, we ensure that our programs are aligned with
                                the latest industry standards, giving our learners the tools
                                they need to thrive in today’s dynamic professional landscape.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer />
        </>
    );
};
export default About;
